import { Title } from '../../basic/help/title';
import { Image } from '../../basic/help/image';
import { ProcedureFormat } from '../../basic/help/procedureFormat';
import { Step } from '../../basic/help/step';
import { Text } from '../../basic/help/text';
import { Alert } from 'components/basic/help/alert';

import UpdateExecuteKeyImg1 from '../../../img/manual/updateExecuteKey/updateExecuteKeyImg1.svg';
import UpdateExecuteKeyImg2 from '../../../img/manual/updateExecuteKey/updateExecuteKeyImg2.svg';
import UpdateExecuteKeyImg3 from '../../../img/manual/updateExecuteKey/updateExecuteKeyImg3.svg';
import UpdateExecuteKeyImg4 from '../../../img/manual/updateExecuteKey/updateExecuteKeyImg4.svg';

export const UpdateExecuteKey = () => {
  return (
    <div>
      <Title>execute-Keyの再発行</Title>
      <Text>
        万が一、execute-Keyが第三者に流出してしまった場合、
        <br />
        設定画面からexecute-Keyを再発行することで流出したexecute-Keyの利用を停止することができます。
      </Text>

      <ProcedureFormat>
        <Step>
          execute-Keyを再発行したいアプリの[設定]ボタンをクリックします。
        </Step>
        <Image src={UpdateExecuteKeyImg1} alt="updateExecuteKey1" width={60} />
        <Step>
          execute-Keyの隣に表示されている[keyの再発行]ボタンをクリックします。
        </Step>
        <Alert>
          execute-Keyを再発行した場合、RICOH Chatbot Serviceのシナリオ設定にある
          <br />
          リクエストヘッダーのexecute-Keyを更新してください。
        </Alert>
        <Image src={UpdateExecuteKeyImg2} alt="updateExecuteKey2" width={60} />
        <Step>ダイアログが表示されるので[OK]ボタンをクリックします。</Step>
        <Image src={UpdateExecuteKeyImg3} alt="updateExecuteKey3" width={60} />
        <Step>
          RICOH Chatbot Serviceのシナリオ設定にあるリクエストヘッダーのexecute-Keyを更新し、[保存]ボタンをクリックします。
        </Step>
        <Image src={UpdateExecuteKeyImg4} alt="updateExecuteKey4" width={30} />
      </ProcedureFormat>
    </div>
  );
};
